import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'
import faker from 'faker'
import testProfile from '@/helpers/testProfile'
import { acoToAES, validateObject } from '@/helpers/acoData'
import store from '@/store'

const { API_URL } = config



let checkoutURL = `${API_URL}/api/checkout/completeuser`

export const checkoutService = {
  checkout,
  testCheckout,
  withProfile
}


async function withProfile(checkoutData) {
  let { productId, style, size, profileId, promoCode } = checkoutData
  if (!productId || !style || !size || !profileId) return console.error(`not enough data - missing either pid,style,size,or profile`)
  let url = `${API_URL}/api/checkout/withprofile`
  let payload = { productId, style, size, profileId }
  if (promoCode) payload.promoCode = promoCode
  let opts = {
    url,
    data: payload,
    method: 'POST',
    headers: authHeader()
  }
  try {
    let res = await axios(opts)
    let { data } = res
    console.log(`checkout resp:`, data)
    if (!data.success) return throw new Error(data.error || 'Error checking out.')
    return data
  } catch (e) {
    console.error(e)
    throw e
  }

}


async function checkout(checkoutData) {
  /* checkout data needs the following
  stripeToken: string or object,
    email,
    name,
    productId,
    acoDataPayload
  */
  console.log(`checkout called, verifying data...`)
  let { email, name, productId, stripeToken, acoData } = checkoutData
  let acoIsValid = validateObject(acoData)
  if (!email || !name || !productId || !stripeToken || !acoData || !acoIsValid) {
    console.error('insufficient checkout data - throwing err')
    return throw new Error('insufficient checkout data')
  }
  console.log(`checking out ${productId} with email ${email} name ${name} and token ${stripeToken}`)
  console.log(`encrypting acoData`)
  let encryptedACOData = acoToAES(acoData)
  console.log(`acoData encrypted to ${encryptedACOData}`)
  let payload = {
    email,
    name,
    productId,
    stripeToken,
    acoDataPayload: encryptedACOData
  }
  let opts = {
    url: checkoutURL,
    data: payload,
    method: 'POST',
    headers: authHeader()
  }
  try {
    let res = await axios(opts)
    let { data } = res
    console.log(`checkout resp:`, data)
    if (!data.success) return throw new Error(data.error || 'Error checking out.')
    return data
  } catch (e) {
    console.log(e)
    throw e
  }

}
async function testCheckout() {
  let name = faker.name.findName()
  let email = faker.internet.userName() + '@graffixed.com'
  console.log(`performing testCheckout for ${email}`)
  let productId = store.state.products.products[0].productId
  let data = {
    email: email,
    name: name,
    productId: productId,
    stripeToken: 'tok_visa',
    acoData: testProfile,
  }
  try {
    console.log(`sendig data to checkout f`, data)
    let checkoutResult = await checkout(data)
    let { order } = checkoutResult
    console.log(`test checkout ${order.orderId} created successfully!`)
    return order
  } catch (e) {
    console.error(`error creating test checkout`, e)
    throw e
  }
}